import React from 'react'
import { Switch, Route, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import NavBar from './NavBar'
import Footer from './Footer'

import HomePage from '../pages/HomePage'
import StressReliefPage  from '../pages/StressReliefPage'
import SleepPage from '../pages/SleepPage'
import InsomniaPage from "../pages/sleep/InsomniaPage" 
import HygienePage from "../pages/sleep/HygienePage"
import IntroMeditatePage from '../pages/IntroMeditatePage'
import IntroRelaxPage from '../pages/IntroRelaxPage'
import MeditatePage from '../pages/MeditatePage'
import NutritionPage from '../pages/NutritionPage'
import MusicPage from '../pages/MusicPage'
import RelaxationPage from '../pages/RelaxationPage'
import YogaPage from '../pages/YogaPage'
import ImageryPage from '../pages/ImageryPage'
import PlayerPage from '../pages/PlayerPage'
import VideoPage from '../pages/VideoPage'

import HomeSectionBG from '../images/bg-home-waves-alt-3x.png'
import AboutSectionBG from '../images/bg-about-ripple3x.png'
import MeditateSectionBG from '../images/bg-about-ripple3x.png'
import MeditateTreesBG from '../images/bg-meditations-trees3x.png'

const Routing = () => {
  const Location = useLocation()
  const Section = Location.pathname.split(`/`)[1]
  let background = ``

  switch (Section) {
    case `meditate`:
      background = MeditateSectionBG
      break
    case `about`:
      background = AboutSectionBG
      break
    case `player`:
      background = MeditateTreesBG
      break
    default:
      background = HomeSectionBG
  }

  const Container = styled.div`
    background-color: #ccc;
    background-image: url('${background}');
    background-position: center center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  `

  const Main = styled.main`
    flex: 1;
  `

  return (
    <Container>
      <Main>
        <NavBar />
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/stressrelief" component={StressReliefPage} />
          <Route exact path="/sleep" component={SleepPage} />
          <Route exact path="/sleep/hygiene" component={HygienePage} />
          <Route exact path="/sleep/insomnia" component={InsomniaPage} />
          <Route exact path="/meditate/introduction" component={IntroMeditatePage} />
          <Route exact path="/relaxation/introduction" component={IntroRelaxPage} />
          <Route exact path="/meditate" component={MeditatePage} />
          <Route exact path="/relaxation" component={RelaxationPage} />
          <Route exact path="/music" component={MusicPage} />
          <Route exact path="/yoga" component={YogaPage} />
          <Route path="/imagery/video" component={VideoPage} />
          <Route path="/yoga/video" component={VideoPage} />
          <Route exact path="/imagery" component={ImageryPage} />
          <Route path="/player" component={PlayerPage} />
          <Route path="/nutrition/" component={NutritionPage} />
          <Route path="*" component={() => '404 not found'} />
        </Switch>
      </Main>
      <Footer />
    </Container>
  )
}

export default Routing
